import React from 'react';
import PropTypes from 'prop-types';
import { ReclamationActionDetailType } from 'constants.js';
import { connect } from 'react-redux';
import { addAction } from 'store/reclamation/reclamationsActions';


import { TypeActionCodes } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

import AddReponseToSavGesteCommercial from './AddReponseToSavGesteCommercial';

class AddReponseToSavGesteCommercialContainer extends React.Component {

    handleClickAccepter = () => {

        const { actionId, reclamationId, addAction } = this.props;

        let actionData = {
            code: TypeActionCodes.SavGesteCommercialReponseDR,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Réponse du directeur régional",
                position: 0,
                valeurInteger: 0,
                valeurString: "Acceptation"
            }]
        };


        addAction(reclamationId, actionData, actionId);


    }

    handleClickRefuser = () => {

        const { actionId, reclamationId, addAction } = this.props;

        let actionData = {
            code: TypeActionCodes.SavGesteCommercialReponseDR,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Réponse du directeur régional",
                position: 0,
                valeurInteger: 1,
                valeurString: "Refus"
            }]
        };


        addAction(reclamationId, actionData, actionId);
    }

    handleClickDemanderInformation = () => {

        const { actionId, reclamationId, addAction } = this.props;

        let actionData = {
            code: TypeActionCodes.SavGesteCommercialReponseDR,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Réponse du directeur régional",
                position: 0,
                valeurInteger: 2,
                valeurString: "Demande d'information"
            }]
        };


        addAction(reclamationId, actionData, actionId);
    }




    render() {
        const { isAdding } = this.props;

        return (
            <AddReponseToSavGesteCommercial

                onClickAccepter={this.handleClickAccepter}
                onClickRefuser={this.handleClickRefuser}
                onClickDemanderInformation={this.handleClickDemanderInformation}
                isAdding={isAdding}
                
            />
        );
    }
}

AddReponseToSavGesteCommercialContainer.propTypes = {
    actionId: PropTypes.number.isRequired,
    reclamationId: PropTypes.number.isRequired
};




const mapStateToProps = (state, ownProps) => ({
    isAdding: state.common.addActionData.actionId === ownProps.actionId
});


const mapDispatchToProps = dispatch => ({
    addAction: (reclamationId, actionData, actionId) => dispatch(addAction(reclamationId, actionData, actionId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddReponseToSavGesteCommercialContainer);